// extracted by css-extract-rspack-plugin
var _1 = "vp";
var _2 = "yc";
var _3 = "yb";
var _4 = "x9";
var _5 = "ya";
var _6 = "ye";
var _7 = "yf";
var _8 = "hi";
var _9 = "fl";
export { _1 as "closeIcon", _2 as "dropDown", _3 as "inputSearchBox", _4 as "multipleSelectComponent", _5 as "multipleSelectItem", _6 as "scrollbar", _7 as "scrollbarItem", _8 as "selected", _9 as "text" }
